import React from "react";
import { Helmet } from "react-helmet-async";
import { withTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import List from "../../components/List/List.js";
import MainHeader from "../../components/MainHeader/MainHeader.js";
function Applications({ t }) {
  const navigate = useNavigate();
  return (
    <>
      <MainHeader title={t("Application list")}>
        <button
          type="button"
          className="header-inner__btn ln-cab__head-btn"
          onClick={() => navigate("/account/applicationsadd")}
        >
          <i className="bx bx-plus" />
          {t("Add application")}
        </button>
      </MainHeader>
      <Helmet>
        <meta charSet="utf-8" />
        <title>Vis Nefrit | {t("Application list")}</title>
      </Helmet>
      <div>
        <List />
      </div>
    </>
  );
}
export default withTranslation()(Applications);
